import { IOrderFull } from '../typings/IOrderItem';

export const checkAllProductsAvailability = (order: IOrderFull): boolean => {
  return order.purchases.every(({ product }) => product.isActive && product.productOptions[0].availableAmount > 0);
};

export const isAllProductsNonAvailable = (order: IOrderFull): boolean => {
  return order.purchases.every(({ product }) => !product.isActive || product.productOptions[0].availableAmount === 0);
};
